import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-table',
    styleUrls: ['./table.component.scss'],
    templateUrl: './table.component.html',
    standalone: false
})
export class TableComponent implements OnInit {

  constructor() { }

  public ngOnInit() {
  }

}
